// extracted by mini-css-extract-plugin
export default {"header_circle_img":"нeaderFlag_header_circle_img__sVLPn","header_cicle":"нeaderFlag_header_cicle__oIS+i"};